export const home = {
  blank: 'En blanco',
};
